import _ from 'lodash';
import {attachUuidKey, splitListBy} from 'utils/common';

export const splitPermissions = permissions => {
  const location: Array<any> = [];
  const generic: Array<any> = [];

  Object.values(permissions).forEach((section: any) => {
    const [withLocation, withoutLocation] = splitListBy(
      section.value,
      entity => entity.requiresLocation
    );

    if (!_.isEmpty(withLocation)) {
      location.push({
        label: section.label,
        value: withLocation.map(attachUuidKey)
      });
    }
    if (!_.isEmpty(withoutLocation)) {
      generic.push({
        label: section.label,
        value: withoutLocation.map(attachUuidKey)
      });
    }
  });

  return [location.map(attachUuidKey), generic.map(attachUuidKey)];
};
